import React, {useEffect} from 'react';

import {loadMetadata, selectMetadata} from 'entities/metadata';
import {selectEntityData} from 'modules/data';
import {createActionHandlerForDelete} from 'modules/data/data-actions';
import {IDirectoryFormEntityData} from 'modules/data/data-types';
import {EEntityType} from 'shared/constants/entities';
import {ERequestType} from 'shared/types/requests';
import {useAppDispatch, useAppSelector} from 'store/config/hooks';

import {ActionButton} from '../action-button';
import {ActionConfirmModal} from '../action-confirm-modal/action-confirm-modal';
import {ITableActionProps} from '../table-action-types';
import {DEFAULT_DELETE_CONFIRM_TEXT} from './constants/button-delete-tab-constants';

export interface IButtonActionDeleteWithWarningProps extends ITableActionProps {
}

export const ButtonActionDeleteTab = ({
    meta,
    entityName,
    wrapper,
    ...props
}: IButtonActionDeleteWithWarningProps) => {
    const dispatch = useAppDispatch();
    const referenceUrl = meta?.referenceUrl || entityName;
    const requestType = meta?.requestType || ERequestType.DELETE;
    const entityType = meta?.parentEntityType as EEntityType || EEntityType.TABS;

    const selectedTab = useAppSelector(state => selectEntityData(
        entityName, entityType,
    )(state) as IDirectoryFormEntityData)?.tab;

    const modalMeta = useAppSelector(
        state => selectMetadata(meta?.modalEntityName || '', EEntityType.FORM)(state),
    );

    useEffect(() => {
        if (!modalMeta && meta?.modalEntityName) {
            dispatch(loadMetadata(meta?.modalEntityName || '', EEntityType.FORM));
        }
    }, []);

    const handleDelete = async () => {
        if (selectedTab) {
            await dispatch(createActionHandlerForDelete(
                {
                    entityName,
                    referenceUrl: `${referenceUrl}/${selectedTab}`,
                    requestType,
                    entityTypes: [entityType],
                },
            ));
        }
    };

    const Component = wrapper || ActionButton;

    return (
        <ActionConfirmModal
            cancelText="Отмена"
            approveText="Удалить"
            modalTitle="Предупреждение"
            confirmModalContent={modalMeta?.title || DEFAULT_DELETE_CONFIRM_TEXT}
            confirmAction={handleDelete}
        >
            {handleClick => (
                <Component
                    {...props}
                    onClick={handleClick}
                    actionIcon={meta.actionIcon}
                >
                    {meta.actionTitle}
                </Component>
            )}
        </ActionConfirmModal>
    );
};
